/** @flow */
import {
  GetAbsenceNow,
  GetAbsenceNowSuccess,
  GetAbsenceNowError,
  GetToolsDashboard,
  GetToolsDashboardSuccess,
  GetToolsDashboardError,
  GetActivityFeedDashboard,
  GetActivityFeedDashboardSuccess,
  GetActivityFeedDashboardError,
  GetFirstCareIndexPageStatistic,
  GetFirstCareIndexPageStatisticSuccess,
  GetFirstCareIndexPageStatisticError,
  GetCoronavirusToolsDashboardSuccess,
  GetCoronavirusToolsDashboardError,
  GetCoronavirusToolsDashboard,
  GetHierarchyBreakdown,
  GetHierarchyBreakdownSuccess,
  GetHierarchyBreakdownError,
} from "@modules/reporting/constants/actions";
import * as dashboardReducers from "./reducers";
import initialState from "./state";
import type { DashboardState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: DashboardState = initialState, action: Object): DashboardState => {
  const act = {
    [GetAbsenceNow]: dashboardReducers.setLoading,
    [GetCoronavirusToolsDashboard]: dashboardReducers.setLoading,
    [GetAbsenceNowSuccess]: dashboardReducers.onGetAbsenceNowSuccess,
    [GetAbsenceNowError]: dashboardReducers.onGetAbsenceNowError,
    // Tools Dashboard
    [GetToolsDashboard]: dashboardReducers.setLoading,
    [GetToolsDashboardSuccess]: dashboardReducers.onGetToolsDashboardSuccess,
    [GetToolsDashboardError]: dashboardReducers.onToolsDashboardError,
    // Activity Feed Dashboard
    [GetActivityFeedDashboard]: dashboardReducers.setLoading,
    [GetActivityFeedDashboardSuccess]: dashboardReducers.onGetActivityFeedDashboardSuccess,
    [GetActivityFeedDashboardError]: dashboardReducers.onToolsDashboardError,
    [GetFirstCareIndexPageStatistic]: dashboardReducers.onGetFirstCareIndexPageStatistic,
    [GetFirstCareIndexPageStatisticSuccess]:
      dashboardReducers.onGetFirstCareIndexPageStatisticSuccess,
    [GetFirstCareIndexPageStatisticError]: dashboardReducers.onToolsDashboardError,
    // Corona virus Dashboard
    [GetCoronavirusToolsDashboardSuccess]: dashboardReducers.onGetCoronavirusToolsDashboardSuccess,
    [GetCoronavirusToolsDashboardError]: dashboardReducers.onToolsDashboardError,

    [GetHierarchyBreakdown]: dashboardReducers.setLoading,
    [GetHierarchyBreakdownSuccess]: dashboardReducers.onGetHierarchyBreakdownSuccess,
    [GetHierarchyBreakdownError]: dashboardReducers.onGetHierarchyBreakdownError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
